import { render, staticRenderFns } from "./ActionDetail1.vue?vue&type=template&id=86f7a078"
import script from "./ActionDetail1.vue?vue&type=script&lang=js"
export * from "./ActionDetail1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports